// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchInput_wrapper__2ZMEA","input":"SearchInput_input__YAKvO"};